import React, { useState, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { withTranslation } from 'react-i18next'
import { PageContext } from '../Context/PageProvider'
import { ReactSVG } from 'react-svg'

function Login({ t, history }) {

    const classes = useStyles()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const context = useContext(PageContext)
    const api = context.api
    const [unauthorized, setUnauthorized] = useState(false)
    const [loading, setLoading] = useState(false)

    const onClickSubmit = async () => {
        try {
            setLoading(true)
            const t = await api.userService.authUser(username, password)
            setLoading(false)
            history.push('/')
        } catch (error) {
            setLoading(false)
            setUnauthorized(true)
        }
    }

    return (

        <Grid container justify="center" alignContent="center" className={classes.container}>
            <ValidatorForm onSubmit={onClickSubmit} className={classes.ValidatorForm}>
                <Grid container justify="center" alignContent="center" className={classes.logoContainer}>
                    <ReactSVG src="/assets/logos/logo_big_primary.svg" width={200} />
                </Grid>
                <TextValidator
                    label={t('username')}
                    name="username"
                    type="text"
                    validators={['required']}
                    errorMessages={[t('this_field_is_required')]}
                    onChange={(event) => { setUsername(event.target.value) }}
                    value={username}
                    className={classes.fields}
                    error={unauthorized}
                />
                <TextValidator
                    label={t('password')}
                    name="password"
                    type="password"
                    validators={['required']}
                    errorMessages={[t('this_field_is_required')]}
                    onChange={(event) => {
                        setPassword(event.target.value)
                    }}
                    value={password}
                    className={classes.fields}
                    error={unauthorized}
                    helperText={unauthorized ? t('error_invalid_username_or_password') : null}
                />
                <Grid container justify="center" alignItems="center">
                    <Button type="submit" className={classes.submit} disabled={password.trim() === "" || username.trim() === "" || loading} variant="contained" color="primary" >{t('sign_in').toUpperCase()}</Button>
                </Grid>
            </ValidatorForm>

            <Grid container className={classes.infoContainer} justify="center">
                <Typography component="small">
                    {t('footer_description')}
                </Typography>
            </Grid>
        </Grid>

    )
}


const useStyles = makeStyles((theme) => ({
    container: {
        position: 'absolute',
        left: 0,
        height: '100%'
    },
    ValidatorForm: {
        width: '100%',
        maxWidth: 340,
    },
    logoContainer: {
        marginBottom: theme.margin.extraLarge
    },
    submit: {
        marginTop: theme.margin.large
    },
    fields: {
        marginBottom: 12,
        '& label': {
            fontWeight: theme.font.weight.medium
        }
    },
    infoContainer: {
        position: 'absolute',
        bottom: 26,
        '& small': {
            color: 'rgba(0,0,0, 0.6)'
        }
    }
}))

export default withTranslation()(withRouter(Login))